import React from 'react';

// Every Sales panel that computes a metric must declare which clock it uses:
//   CASH  — payment date (revenue, pace-to-plan)
//   COHORT — consult date (close rate, no-show rate, win rate)
// Panels never mix the two silently.
export function ClockLabel({ type, testId }) {
  const styles = {
    cash: 'bg-indie-cobalt text-white',
    cohort: 'bg-indie-yellow text-indie-ink',
  }[type] || 'bg-indie-ink/20 text-indie-ink';

  const label = type === 'cash'
    ? 'CASH · payment date'
    : type === 'cohort'
      ? 'COHORT · consult date'
      : 'CLOCK';

  return (
    <span
      data-testid={testId || `clock-label-${type}`}
      className={`inline-block text-[9px] uppercase tracking-[0.16em] font-semibold px-1.5 py-0.5 ${styles}`}
      title={type === 'cash'
        ? 'Metric is keyed to payment date. Matches QBO/dailyhighlight/BHAG revenue.'
        : type === 'cohort'
          ? 'Metric is keyed to consult date. Numerator and denominator come from the same population; the correct clock for conversion rates.'
          : ''}
    >
      {label}
    </span>
  );
}
